export enum MissingCarePlanSignatureTypeEnum {
    Neither = 0,
    Member = 1,
    Provider = 2,
    Both = 3,
    Expired = 4,
    NotReviewed = 5,
}
